<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="待审核" name="1"></el-tab-pane>
      <el-tab-pane label="已审核" name="2"></el-tab-pane>
      <el-tab-pane label="未通过" name="3"></el-tab-pane>
    </el-tabs>

    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">创建时间</span>
        <el-date-picker
            v-model="date"
            style="width: 300px;"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">分类</span>
        <el-select v-model="area" class="w150" placeholder="不限" clearable>
          <el-option v-for="(item, index) in areaList" :key="index" :label="item.name" :value="item.value"/>
        </el-select>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">活动类型</span>
        <el-select v-model="area" class="w150" placeholder="不限" clearable>
          <el-option v-for="(item, index) in areaList" :key="index" :label="item.name" :value="item.value"/>
        </el-select>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">发布人</span>
        <el-input v-model.trim="phone" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary">
          搜索
        </el-button>
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="" label="活动标题"></el-table-column>
      <el-table-column align="center" prop="" label="活动类型"></el-table-column>
      <el-table-column align="center" prop="" label="发布人"></el-table-column>
      <el-table-column align="center" prop="" label="开始时间"></el-table-column>
      <el-table-column align="center" prop="" label="截止时间"></el-table-column>
      <el-table-column align="center" prop="" label="创建时间"></el-table-column>

      <template v-if="activeName == '2'">
        <el-table-column align="center" prop="" label="访问量"></el-table-column>
        <el-table-column align="center" prop="" label="参与人数"></el-table-column>
        <el-table-column align="center" prop="" label="报名人数"></el-table-column>
        <el-table-column align="center" prop="" label="选手人数"></el-table-column>
        <el-table-column align="center" prop="" label="累计投票"></el-table-column>
        <el-table-column align="center" prop="" label="状态"></el-table-column>
      </template>
      <template v-else>
        <el-table-column align="center" prop="" label="未通过原因"></el-table-column>
      </template>

      <el-table-column align="center" label="操作">
        <template slot-scope="{row}">
          <a class="glob-a" v-if="activeName == '1'">审核</a>
          <a class="glob-a" v-else>审核</a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    name: 'SmallAuth',
    data () {
      return {
        date: '',
        phone: '',
        area: '',
        areaList: [],
        status: '1',
        tableData: [{1: 1}, {1: 1}, {1: 1}, {1: 1},],
        tableLoading: false,
        activeName: '1'
      }
    },
    methods: {
      handleClick (val) {

      }
    }
  }
</script>

<style scoped>

</style>
